import {
  FirestoreOrganisationMarketplace,
  SeasonalEventRegion,
} from "reedy-data/models";
import type { SeasonalEvent } from "integrations/firebase/collections/seasonalEvents";

const MARKETPLACE_REGIONS: Partial<
  Record<FirestoreOrganisationMarketplace, SeasonalEventRegion>
> = {
  [FirestoreOrganisationMarketplace.US]: SeasonalEventRegion.US,
  [FirestoreOrganisationMarketplace.UK]: SeasonalEventRegion.UK,
  [FirestoreOrganisationMarketplace.GER]: SeasonalEventRegion.DE,
  [FirestoreOrganisationMarketplace.AU]: SeasonalEventRegion.AUS,
};

export const getSeasonalEventRegion = (
  marketplace: FirestoreOrganisationMarketplace | null | undefined,
): SeasonalEventRegion | null =>
  marketplace ? (MARKETPLACE_REGIONS[marketplace] ?? null) : null;

export const filterEventsForMarketplace = (
  events: SeasonalEvent[],
  marketplace: FirestoreOrganisationMarketplace | null | undefined,
): SeasonalEvent[] => {
  const homeRegion = getSeasonalEventRegion(marketplace);
  const visibleRegions = new Set<SeasonalEventRegion>([
    SeasonalEventRegion.INTERNATIONAL,
  ]);
  if (homeRegion !== null) {
    visibleRegions.add(homeRegion);
  }

  return events.filter((event) => visibleRegions.has(event.region));
};
